import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { DelaStarIcon } from '~/modules/common/components';
import { useBulkAcceptAllocationsForResourceRequest } from '~/modules/resourcing/common/hooks/useBulkAcceptAllocationsForResourceRequest';
import { useAllocationChartContext } from '~/modules/projects/resourcing-plan/ResourcingPlanPage/contexts';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    backgroundImage: `linear-gradient(119deg, ${theme.palette.Dela.button.gradient.purple} 17.59%, ${theme.palette.Dela.button.gradient.blue} 77.78%)`,
    boxShadow: 'none'
  },
  text: {
    textTransform: 'uppercase'
  },
  delaStarIcon: {
    color: theme.palette.common.white,
    marginRight: theme.spacing(0.5)
  }
}));

export const ResourceRequestAcceptAllButton = ({ resourceRequests }) => {
  const classes = useStyles();

  const {
    bulkAcceptAllocationsForResourceRequest
  } = useBulkAcceptAllocationsForResourceRequest();
  const { allocationChartRef } = useAllocationChartContext();

  const handleAcceptAll = useCallback(() => {
    bulkAcceptAllocationsForResourceRequest({
      acceptAllocationInput: resourceRequests.map(resourceRequest => ({
        resourceRequestId: resourceRequest.id,
        userIds: resourceRequest.resourceMatches?.length
          ? [resourceRequest.resourceMatches[0].userUri]
          : []
      })),
      allocationChartRef
    });
  }, [
    bulkAcceptAllocationsForResourceRequest,
    resourceRequests,
    allocationChartRef
  ]);

  return (
    <Button
      className={classes.root}
      onClick={handleAcceptAll}
      variant="contained"
    >
      <DelaStarIcon className={classes.delaStarIcon} />
      <FormattedMessage
        className={classes.text}
        id="resourceRequestChartBanner.acceptAll"
      />
    </Button>
  );
};

ResourceRequestAcceptAllButton.propTypes = {
  resourceRequests: PropTypes.array.isRequired
};

export default ResourceRequestAcceptAllButton;
